import { render, staticRenderFns } from "./projectData.vue?vue&type=template&id=42eab9a6&"
import script from "./projectData.vue?vue&type=script&lang=js&"
export * from "./projectData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports